// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"355": "code_activation-CodeActivationModal","58": "code_activation-PhoneVerification",}[chunkId] + "." + {"355": "c56ab38a3a9fe4e9","58": "b2ef486e54170135",}[chunkId] + ".js"
}